export default "__VITE_ASSET__BT7HVh2d__"